import { getEnvType } from "../Networking/NetworkingUtils"
import { getCookie, getCookieNoCrypto, setCookie } from "../Utils/CookieHelper";
import Service from '../Networking/NetworkingUtils'
import { msClientId } from "../Login/authProvider";

const SAS_EXPIRY_BUFFER_MS = 30 * 1000;
const inFlightSASRequests = new Map();

export function blobDomain() {
    if (getEnvType() === "prod") {
        return 'https://drstorageprod-fd-hcezh5aya8brbwg6.a01.azurefd.net/'
    } else if (getEnvType() === "qa") {
        return 'https://bbversestorageqa-f8dkbkcudfadauge.z01.azurefd.net/'
    }
    return 'https://bbverseblobdev-hmgaeqaud0ekgrcs.z01.azurefd.net/'
}

export function blobNoCacheDomain() {
    if (getEnvType() === "prod") {
        return 'https://drstorageprod.blob.core.windows.net/'
    } else if (getEnvType() === "qa") {
        return 'https://bbversestorageqa.blob.core.windows.net/'
    }
    return "https://bbverseblobdev.blob.core.windows.net/"
}

function getExistingSASToken(obj) {
    const sasToken = getCookie('sas_token');
    if (sasToken) {
        try {
            let returnReponse = null;
            const parsedToken = JSON.parse(sasToken);
            if (parsedToken && parsedToken[obj.token_type] && parsedToken[obj.token_type][obj.container_name]) {
                const expiryTime = new Date(parsedToken[obj.token_type][obj.container_name].expiry);
                const currentTime = Date.now();
                const isValidExpiry = !Number.isNaN(expiryTime.getTime()) && (expiryTime.getTime() - SAS_EXPIRY_BUFFER_MS) > currentTime;
                if (isValidExpiry) {
                    returnReponse = {
                        "account_url": parsedToken.account_url,
                        "fd_account_url": parsedToken.fd_account_url,
                        [obj.token_type]: {
                            [obj.container_name]: {
                                "sas_token": parsedToken[obj.token_type][obj.container_name].sas_token,
                                "expiry": parsedToken[obj.token_type][obj.container_name].expiry
                            }
                        }
                    }
                }
            }
            return returnReponse;
        } catch (error) {
            console.error('Error parsing SAS token from cookie:', error);
            return null;
        }
    }
    return null;
}

export function isSASTokenExpired(obj) {
    const existingToken = getExistingSASToken(obj);
    return !existingToken;
}

async function requestNewSASToken(obj) {
    const res = await Service.post('/api/projects/authentication/get_sas_token_by_type_and_container/', {
        headers: {
            Authorization: getCookieNoCrypto('msal.' + msClientId + '.idtoken'),
        },
        data: obj
    });

    updateSASTokenInCookie(res.data);
    return res.data;
}

export async function blobSAS(obj) {
    try {

        const existingToken = getExistingSASToken(obj);
        if (existingToken) {
            return existingToken;
        }

        const requestKey = `${obj.token_type}:${obj.container_name}`;
        if (inFlightSASRequests.has(requestKey)) {
            return await inFlightSASRequests.get(requestKey);
        }

        const requestPromise = requestNewSASToken(obj)
            .finally(() => {
                inFlightSASRequests.delete(requestKey);
            });
        inFlightSASRequests.set(requestKey, requestPromise);
        return await requestPromise;
    } catch (error) {
        console.log(error);
        return "";
    }


    // if (getEnvType() === "prod") {
    //     return 'sv=2022-11-02&ss=bfqt&srt=co&sp=rtfx&se=2025-06-29T19:03:48Z&st=2025-01-23T11:03:48Z&spr=https&sig=%2B%2Fj2%2FWw20SQRTSYv43cvsBIxWL0HfkgndU26SrGEC2k%3D'
    // } else if (getEnvType() === "qa") {
    //     return 'sv=2024-11-04&ss=bfqt&srt=sco&sp=rtfx&se=2026-03-30T18:36:21Z&st=2026-02-23T10:21:21Z&spr=https,http&sig=wVPFH2zrOHey%2Bi%2BeWwlOazpB75ud2gLe2i48nkOgaSo%3D'
    // }
    // return 'sv=2024-11-04&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2027-06-30T15:04:20Z&st=2026-02-17T06:49:20Z&spr=https,http&sig=vJQhpqy0oPghMG3EBOu3wspJQcITiiygwWxVbbzOmqY%3D'
}

function updateSASTokenInCookie(newToken) {
    const sasToken = getCookie('sas_token')
    if (sasToken) {
        try {
            const parsedToken = JSON.parse(sasToken);

            const tokenTypes = ['read_only', 'write_only'];
            const mergedTokenTypes = {};

            for (let i = 0; i < tokenTypes.length; i++) {
                const tokenType = tokenTypes[i];
                mergedTokenTypes[tokenType] = {
                    ...(parsedToken[tokenType] || {}),
                    ...(newToken[tokenType] || {})
                };
            }

            const updatedToken = {
                ...parsedToken,
                ...newToken,
                ...mergedTokenTypes
            };
            setCookie('sas_token', JSON.stringify(updatedToken), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'None', 'path': '/', })
        } catch (error) {
            console.error('Error updating SAS token in cookie:', error);
        }
    } else {
        setCookie('sas_token', JSON.stringify(newToken), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'None', 'path': '/', })
    }
}

export async function blobWriteString(obj) {
    try {
        const sasData = await blobSAS(obj);
        let string = sasData.account_url + "?" + sasData[obj.token_type]?.[obj.container_name]?.sas_token
        return string
    } catch (error) {
        console.log(error);
        return;
    }
}

export function handleCacheControl(url) {

    if (url.match(/\.wasm/) || url.match(/\.data/) || url.match(/\.bundle/)) {

        // return "must-revalidate";
        return 'immutable'

    }

    if (url.match(/\.mp4/) || url.match(/\.wav/)) {

        return "immutable";

    }

    return "no-store";

}

export function blobServiceClientFunc(obj) {
    if (getEnvType() === "prod") {
        return blobServiceClientFuncForPROD(obj)
    } else if (getEnvType() === "qa") {
        return blobServiceClientForDEV(obj)
    } else {
        return blobServiceClientFuncForDev(obj)
    }
}

// function blobServiceClientFuncForQA() {
//     const { BlobServiceClient } = require("@azure/storage-blob");
//     const { InteractiveBrowserCredential } = require("@azure/identity");
//     window.Buffer = require("buffer").Buffer;

//     const blobSasUrl = blobWriteString()

//     const blobServiceClient = new BlobServiceClient(blobSasUrl, new InteractiveBrowserCredential(
//         {
//             tenantId: "a04222fe-0c5c-40bb-8420-97a219ba514e",
//             clientId: "64073365-5a03-4736-b34e-597376266a0c"
//         }
//     ));
//     return blobServiceClient
// }

async function blobServiceClientFuncForDev(obj) {
    const { BlobServiceClient } = require("@azure/storage-blob");
    window.Buffer = require("buffer").Buffer;


    const blobSasUrl = await blobWriteString(obj);
    const blobServiceClient = new BlobServiceClient(blobSasUrl);
    // // const blobServiceClient = new BlobServiceClient(blobSasUrl, new InteractiveBrowserCredential(
    // //     {
    // //         tenantId: "a04222fe-0c5c-40bb-8420-97a219ba514e",
    // //         clientId: "64073365-5a03-4736-b34e-597376266a0c"
    // //     }
    // // ));
    return blobServiceClient;
}

export async function blobServiceClientFuncForPROD(obj) {
    const { BlobServiceClient } = require("@azure/storage-blob");
    window.Buffer = require("buffer").Buffer;

    const blobSasUrl = await blobWriteString(obj)
    console.log(blobSasUrl)
    const blobServiceClient = new BlobServiceClient(blobSasUrl);
    return blobServiceClient
}

export async function blobServiceClientForDEV(obj) {
    const { BlobServiceClient } = require("@azure/storage-blob");
    window.Buffer = require("buffer").Buffer;

    const blobSasUrl = await blobWriteString(obj)
    console.log(blobSasUrl)
    const blobServiceClient = new BlobServiceClient(blobSasUrl);
    console.log(blobServiceClient)
    return blobServiceClient
}

export function generateRandomString(length = 16) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
}